import { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import "./testPreviewComponent.scss";
import { useDispatch, useSelector } from "react-redux";
import produce from "immer";
import { startEditSession } from "../../actions/sessionListAction";
import { AppState } from "../../reducers/rootReducer";
import { getViewRemark } from "../../selectors/appSelectors";
import { adminUserRole } from "../../utils/constants";

type TParams = { type: string; id: string };

const TestPreviewComponent = ({ match }: RouteComponentProps<TParams>) => {
  const [viewType, setViewType] = useState("desktop-iframe");
  const [position, setPosition] = useState("right");
  const dispatch = useDispatch();
  const sessionState = useSelector((state: AppState) => state.session);
  const remarkState = useSelector(getViewRemark);
  const rowState = useSelector((state: AppState) => state.rowList);
  const userRole = localStorage.getItem("userRoleId");

  const viewRemarks = () => {
    const newSession = produce(sessionState, (draft) => {
      draft.viewRemark = !draft.viewRemark;
    });
    dispatch(startEditSession(newSession));
  };

  useEffect(() => {
    console.log(rowState);
  });

  function buildHtml(body: string) {
    var jQuery =
      '<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>';
    var boostrap =
      '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous" />';
    var react =
      '<script src="https://unpkg.com/react/umd/react.production.min.js" crossorigin></script><script src="https://unpkg.com/react-dom/umd/react-dom.production.min.js" crossorigin></script></script><script src="https://unpkg.com/react-bootstrap@next/dist/react-bootstrap.min.js" crossorigin></script> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" integrity="sha384-KyZXEAg3QhqLMpG8r+8fhAXLRk2vvoC2f3B09zVXn8CA5QIVfZOJ3BCsw2P0p/We" crossorigin="anonymous"/>';
    var header = boostrap + jQuery + react;

    // concatenate header string
    // concatenate body string
    var test =
      '<input id="4b4c5e4d-0ea7-440d-a59c-861761872ba8" type="text" class="form-control " placeholder="placeholder">';
    const firstInputItem = document.getElementsByTagName("input")[0];
    if (firstInputItem !== undefined) {
      body =
        '<input id="0" type="text" class="form-control " placeholder="placeholder"/>';
    }
    return (
      "<!DOCTYPE html>" +
      "<html><head>" +
      header +
      "</head><body>" +
      body +
      "</body></html>"
    );
  }

  const downloadPreview = async () => {
    let content = "";
    const root = document.getElementById("root");
    const iframe = root?.querySelector("iframe");
    const iframeRoot = iframe?.contentDocument?.getElementById("root");
    const html = iframeRoot?.innerHTML;
    if (html !== undefined) {
      content = html;
    }
    const element = document.createElement("a");
    const file = new Blob([buildHtml(content)], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "myFile.html";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    // const path = await formService.createFormDownload({name: 'page', body: content})
    // console.log(path);
  };

  const defaultStyles = {
    right:
      position === "right" ? "2%" : userRole === adminUserRole ? "80%" : "84%",
  };

  return (
    <div className="conitaner-fluid">
      <div className="d-flex justify-content-center">
        <div className={`${viewType} emulator p-0`}>
          <iframe
            title="preview"
            className="custom-iframe"
            src={`/${match.params.type}/${match.params.id}`}
          ></iframe>
        </div>
      </div>
      <div
        className="row view-button justify-content-center"
        style={{ ...defaultStyles }}
      >
        {position === "right" && (
          <i
            className="btn fa fa-arrow-left"
            style={{ fontSize: "16pt" }}
            onClick={() => {
              setPosition("left");
            }}
          ></i>
        )}
        {/* <Tooltip title="Deactive / Active View Remarks">
        <Switch
        checked={sessionState.viewRemark}
        onChange={() => {
        viewRemarks();
        }}
        onColor="#86d3ff"
        onHandleColor="#2693e6"
        handleDiameter={15}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={10}
        width={24}
        className="react-switch mt-3 ml-2"
        id="btn-outline"
        />
        </Tooltip> */}
        <i
          className="btn fa fa-mobile"
          style={{ fontSize: "20pt" }}
          onClick={() => {
            setViewType("mobile-iframe");
          }}
        ></i>
        <i
          className="btn fa fa-tablet"
          style={{ fontSize: "20pt" }}
          onClick={() => {
            setViewType("tablet-iframe");
          }}
        ></i>
        <i
          className="btn fa fa-laptop"
          style={{ fontSize: "20pt" }}
          onClick={() => {
            setViewType("medium-iframe");
          }}
        ></i>
        <i
          className="btn fa fa-desktop"
          style={{ fontSize: "20pt" }}
          onClick={() => {
            setViewType("desktop-iframe");
          }}
        ></i>
        {userRole === adminUserRole && match.params.type==="preview-render" &&(
          <i
            className="btn fa fa-download"
            style={{ fontSize: "20pt" }}
            onClick={() => {
              downloadPreview();
            }}
          ></i>
        )}
        {position !== "right" && (
          <i
            className="btn fa fa-arrow-right"
            style={{ fontSize: "16pt" }}
            onClick={() => {
              setPosition("right");
            }}
          ></i>
        )}
      </div>
    </div>
  );
};

export default TestPreviewComponent;
